import React, { useEffect, useState, useContext } from "react"
import MetaTags from "react-meta-tags"
import { get, post, put } from "helpers/api_helper"
//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"
import {
  Col,
  Card,
  CardBody,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import { getOrderStatus } from "utils/helpers/order"
import { CustomAlertContext } from "utils/context/CustomAlertContext"
import Autosuggest from "react-autosuggest"
import ConfirmationModal from "components/Common/Modals/ConfirmationModal"
import SpinnerLoader from "components/Loader/SpinnerLoader"

dayjs.extend(utc)

const ImagePreview = ({ link }) => (
  <div className="p-2">
    <a href={link} target="_blank">
      <img
        src={link}
        width={100}
        height={100}
        style={{
          objectFit: "cover",
          borderRadius: 6,
          border: "1px solid #e9ecef",
        }}
      />
    </a>
  </div>
)

const SectionHeader = ({ title, icon }) => (
  <div className="mt-4 mb-3">
    <h6
      className="text-uppercase text-muted fw-semibold mb-1"
      style={{ fontSize: "0.7rem", letterSpacing: "0.08em" }}
    >
      {icon && <i className={`mdi ${icon} me-1`} />}
      {title}
    </h6>
    <hr className="mt-1 mb-0" />
  </div>
)

const InfoRow = ({ label, value }) => (
  <div className="mb-2">
    <div className="text-muted" style={{ fontSize: "0.72rem" }}>
      {label}
    </div>
    <div>{value || "—"}</div>
  </div>
)

const InfoBox = ({ icon, iconColor, title, children }) => (
  <div
    className="p-3 h-100"
    style={{
      border: "1px solid #e9ecef",
      borderRadius: 8,
      background: "#fafafa",
    }}
  >
    <div className="d-flex align-items-center mb-2">
      <i className={`mdi ${icon} me-2 text-${iconColor}`} />
      <strong>{title}</strong>
    </div>
    {children}
  </div>
)

function formatAction(action) {
  return action
    .split("_")
    .map(w => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ")
}

function getActorBadge(actor) {
  const map = {
    system: "bg-soft-secondary text-dark",
    customer: "bg-soft-info text-info",
    admin: "bg-soft-warning text-warning",
    driver: "bg-soft-success text-success",
  }
  return (
    <span
      style={{ textTransform: "capitalize" }}
      className={`badge ${map[actor] || "bg-soft-secondary text-dark"}`}
    >
      {actor}
    </span>
  )
}

function getPackageWeight(weight) {
  if (weight == 3) return `1 kg - 3 kg`
  else if (weight == 10) return `3 kg - 10 kg`
  else if (weight == 15) return `10 kg - 15 kg`
  else return `${weight} kg`
}

const ViewOrder = props => {
  const [order, setOrder] = useState({})
  const [deliver_guys, setDeliverGuys] = useState({})
  const [loading, setLoading] = useState(false)
  const [deliverGuy, setDeliverGuy] = useState({})
  const customAlert = useContext(CustomAlertContext)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [showPickupDateModal, setShowPickupDateModal] = useState(false)
  const [pickupDate, setPickupDate] = useState("")
  const [pickupTime, setPickupTime] = useState("")

  const [suggestions, setSuggestions] = useState([])
  const [value, setValue] = useState("")

  useEffect(() => {
    setLoading(true)
    get(`order/${props.match.params.id}`).then(res => {
      const { status, result } = res
      setOrder(result)
      getDeliverGuys()
      setLoading(false)
    })
  }, [])

  const getDeliverGuys = () => {
    get("to-assign-deliverGuys").then(res => {
      const { status, result } = res
      let deliverGuys =
        result.length &&
        result.map(dg => {
          dg.name = `${dg.first_name} ${dg.last_name || ""}`
          return dg
        })
      setDeliverGuys(deliverGuys)
    })
  }

  const getSuggestions = value => {
    const inputValue = value.trim().toLowerCase()
    const inputLength = inputValue.length
    return inputLength === 0
      ? []
      : deliver_guys.filter(
          lang => lang.name.toLowerCase().slice(0, inputLength) === inputValue
        )
  }

  const getSuggestionValue = suggestion => suggestion.name

  const renderSuggestion = suggestion => (
    <div className="d-flex align-items-center justify-content-between gap-2">
      <div className="d-flex align-items-center gap-2">
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            background: "#e8f0fe",
            color: "#3c6ef4",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: "0.8rem",
            flexShrink: 0,
          }}
        >
          {suggestion.name.charAt(0).toUpperCase()}
        </div>
        <div>
          <div style={{ fontWeight: 500, fontSize: "0.875rem" }}>
            {suggestion.name}
          </div>
          <div style={{ fontSize: "0.75rem", color: "#888" }}>
            {suggestion.contact_number}
          </div>
        </div>
      </div>
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          flexShrink: 0,
          backgroundColor: suggestion.online_status ? "#34c38f" : "#adb5bd",
        }}
        title={suggestion.online_status ? "Online" : "Offline"}
      />
    </div>
  )

  const onChange = (event, { newValue }) => {
    setValue(newValue)
  }

  const onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    setDeliverGuy(suggestion)
  }

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value))
  }

  const renderSuggestionsContainer = ({ containerProps, children, query }) => {
    const noResults =
      query.trim().length > 0 &&
      suggestions.length === 0 &&
      deliverGuy.name !== query
    const { className, ...rest } = containerProps
    const cls = noResults
      ? className.replace(
          "react-autosuggest__suggestions-container",
          "react-autosuggest__suggestions-container react-autosuggest__suggestions-container--open"
        )
      : className
    return (
      <div {...rest} className={cls}>
        {children}
        {noResults && (
          <div
            style={{
              padding: "10px 12px",
              fontSize: "0.875rem",
              color: "#888",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <i className="mdi mdi-account-search" />
            No driver found for &ldquo;{query}&rdquo;
          </div>
        )}
      </div>
    )
  }

  const onSuggestionsClearRequested = () => {
    setSuggestions([])
  }

  const inputProps = {
    placeholder: "Type Driver Name",
    value,
    onChange: onChange,
    className: "form-control",
  }

  const markDelivered = () => {
    post("order-status", {
      order_id: order._id,
      status: 3,
    })
      .then(res => {
        const { result } = res
        customAlert.notify(res.message)
        result ? setOrder({ ...order, status: 3 }) : ""
      })
      .catch(error => {
        customAlert.notify(error.response.data.message, "error")
      })
  }

  const toggleCancelModal = () => {
    setShowCancelModal(!showCancelModal)
  }

  const handleConfirmOrderDelete = () => {
    post("order-status", {
      order_id: order._id,
      status: 4,
    })
      .then(res => {
        const { result, message } = res
        customAlert.notify(message)
        if (result) {
          setOrder({ ...order, status: 4 })
        }
      })
      .catch(error => {
        customAlert.notify(error.response.data.message, "error")
      })
      .finally(() => {
        toggleCancelModal()
      })
  }

  const handleAssignDriver = () => {
    let data = {
      order_id: props.match.params.id,
      deliverGuy,
    }
    post(`assign-driver`, data)
      .then(res => {
        const { result } = res
        customAlert.notify(res.message)
        setOrder(result)
        setValue("")
      })
      .catch(error => {
        customAlert.notify(error.response.data.message, "error")
      })
  }

  const handleUpdatePickupDate = () => {
    if (!pickupDate || !pickupTime) return
    const utcTime = dayjs(`${pickupDate}T${pickupTime}`).utc().toISOString()
    put(`order/pickup-time/${order._id}`, { time_slot: utcTime })
      .then(res => {
        customAlert.notify(res.message)
        setOrder({ ...order, time_slot: utcTime })
        setShowPickupDateModal(false)
        setPickupDate("")
        setPickupTime("")
      })
      .catch(error => {
        customAlert.notify(error.response.data.message, "error")
      })
  }

  const getAddressLine = key => {
    let addressLine = ""
    if (order[key].building_name) {
      addressLine += "Building - " + order[key].building_name + ", "
    }
    if (order[key].unit_number) {
      addressLine += "Block - " + order[key].unit_number + ", "
    }
    if (order[key].floor_number) {
      addressLine += "Floor - " + order[key].floor_number + ", "
    }
    if (order[key].landmark) {
      addressLine += "Landmark - " + order[key].landmark + ", "
    }
    addressLine += order[key].address
    return addressLine
  }

  const getAddressLink = key => {
    let link = ""
    if (order[key].lat && order[key].lng) {
      link = `https://www.google.com/maps/search/?api=1&query=${order[key].lat}%2C${order[key].lng}`
    }
    return link ? (
      <a href={link} target="_blank">
        <i className="mdi mdi-map-marker" />
      </a>
    ) : null
  }

  const currency = order.amount?.currency || "ZAR"

  return (
    <>
      <Modal
        isOpen={showPickupDateModal}
        toggle={() => setShowPickupDateModal(false)}
      >
        <ModalHeader toggle={() => setShowPickupDateModal(false)}>
          Update Pickup Date
        </ModalHeader>
        <ModalBody>
          <Label for="pickupDateInput">Pickup Date</Label>
          <Input
            id="pickupDateInput"
            type="date"
            value={pickupDate}
            min={dayjs().format("YYYY-MM-DD")}
            onChange={e => {
              setPickupDate(e.target.value)
              setPickupTime("")
            }}
            className="mb-2"
          />
          <Label for="pickupTimeInput">Pickup Time</Label>
          <Input
            id="pickupTimeInput"
            type="time"
            value={pickupTime}
            min={
              pickupDate === dayjs().format("YYYY-MM-DD")
                ? dayjs().format("HH:mm")
                : undefined
            }
            onChange={e => setPickupTime(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdatePickupDate}>
            Update
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowPickupDateModal(false)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <ConfirmationModal
        toggleModal={toggleCancelModal}
        isOpenModal={showCancelModal}
        deleteRecord={handleConfirmOrderDelete}
        title={"Cancel Order #" + order.order_track_id}
        text={
          order.status == 2
            ? "Order is already PICKED UP by the rider. Do you really want to cancel this order"
            : "Do you really want to cancel this order"
        }
        extraInfo={
          "*In case of cancellation by admin, a full refund will be processed to the customer."
        }
      />

      <div className="page-content">
        <MetaTags>
          <title>Orders | GoFetchIt</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumb
            breadcrumb1={{ title: "Orders", href: "/orders" }}
            breadcrumbItem="View Order"
          />
          {loading ? (
            <SpinnerLoader />
          ) : (
            <Card>
              <CardBody>
                {/* ── Action Bar ── */}
                {[0, 1, 2].includes(order.status) ? (
                  <Row className="align-items-center mb-3 pb-3 border-bottom g-2">
                    {[0, 1].includes(order.status) ? (
                      <>
                        <Col md={5} className="d-flex gap-2 align-items-center">
                          <div className="autosuggest-wrap flex-grow-1">
                            <Autosuggest
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={
                                onSuggestionsFetchRequested
                              }
                              onSuggestionsClearRequested={
                                onSuggestionsClearRequested
                              }
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              renderSuggestionsContainer={
                                renderSuggestionsContainer
                              }
                              inputProps={inputProps}
                              onSuggestionSelected={onSuggestionSelected}
                            />
                          </div>
                          <Button
                            color="primary"
                            onClick={handleAssignDriver}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            <i className="mdi mdi-account-check me-1" />
                            Assign Driver
                          </Button>
                        </Col>
                      </>
                    ) : null}
                    <Col className="d-flex justify-content-end">
                      <Button
                        color="danger"
                        outline
                        onClick={toggleCancelModal}
                      >
                        <i className="mdi mdi-close-circle-outline me-1" />
                        Cancel Order
                      </Button>
                    </Col>
                  </Row>
                ) : null}

                {/* ── Order Header: Status + Track ID ── */}
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex align-items-center gap-2">
                    {getOrderStatus(order.status)}
                    {order.is_return_order ? (
                      <span className="badge bg-soft-warning text-warning">
                        Return Order
                      </span>
                    ) : null}
                    {order?.parent_order?.order_track_id ? (
                      <span
                        className="text-muted"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Original:{" "}
                        <a
                          href={`/orders/view/${
                            order.parent_order?._id ||
                            order.parent_order?.id ||
                            ""
                          }`}
                          className="badge bg-soft-primary text-primary"
                        >
                          #{order.parent_order.order_track_id}
                        </a>
                      </span>
                    ) : null}
                  </div>
                  <h5 className="mb-0 text-muted fw-semibold">
                    #{order.order_track_id}
                  </h5>
                </div>

                {/* ── Addresses ── */}
                <SectionHeader
                  title="Addresses"
                  icon="mdi-map-marker-multiple"
                />
                <Row className="g-3">
                  <Col md={6}>
                    {order.pickup_address ? (
                      <InfoBox
                        icon="mdi-package-up"
                        iconColor="primary"
                        title="Pickup"
                      >
                        <InfoRow
                          label="Sender"
                          value={order.pickup_address.sender_name}
                        />
                        <InfoRow
                          label="Contact"
                          value={order.pickup_address.contact_number}
                        />
                        <div
                          className="text-muted"
                          style={{ fontSize: "0.72rem" }}
                        >
                          Address
                        </div>
                        <div>
                          {getAddressLink("pickup_address")}{" "}
                          {getAddressLine("pickup_address")}
                        </div>
                      </InfoBox>
                    ) : null}
                  </Col>
                  <Col md={6}>
                    {order.delivery_address ? (
                      <InfoBox
                        icon="mdi-package-variant-closed"
                        iconColor="success"
                        title="Delivery"
                      >
                        <InfoRow
                          label="Recipient"
                          value={order.delivery_address.recipient_name}
                        />
                        <InfoRow
                          label="Contact"
                          value={order.delivery_address.contact_number}
                        />
                        <div
                          className="text-muted"
                          style={{ fontSize: "0.72rem" }}
                        >
                          Address
                        </div>
                        <div>
                          {getAddressLink("delivery_address")}{" "}
                          {getAddressLine("delivery_address")}
                        </div>
                      </InfoBox>
                    ) : null}
                  </Col>
                </Row>

                {/* ── People ── */}
                <SectionHeader title="People" icon="mdi-account-group" />
                <Row className="g-3">
                  <Col md={6}>
                    {order.customer_details ? (
                      <InfoBox
                        icon="mdi-account"
                        iconColor="info"
                        title="Customer"
                      >
                        <InfoRow
                          label="Name"
                          value={
                            <a
                              href={`/customers/view/${order.customer_details._id}`}
                              target="blank"
                            >
                              {`${order.customer_details.first_name} ${
                                order.customer_details.last_name || ""
                              }`}
                            </a>
                          }
                        />
                        <InfoRow
                          label="Contact"
                          value={
                            <a
                              href={`tel:${order.customer_details.contact_number}`}
                            >
                              {order.customer_details.contact_number}
                            </a>
                          }
                        />
                      </InfoBox>
                    ) : null}
                  </Col>
                  <Col md={6}>
                    {order.assigned ? (
                      <InfoBox
                        icon="mdi-bike-fast"
                        iconColor="warning"
                        title="Delivery Person"
                      >
                        <InfoRow
                          label="Name"
                          value={
                            <a
                              href={`/deliver-guys/view/${order.assigned.deliverGuy_id}`}
                              target="blank"
                            >
                              {order.assigned.full_name}
                            </a>
                          }
                        />
                        <InfoRow
                          label="Vehicle"
                          value={order.assigned.vehicle}
                        />
                        <InfoRow
                          label="Vehicle No."
                          value={order.assigned.vehicle_no}
                        />
                        <InfoRow
                          label="Contact"
                          value={
                            <a href={`tel:${order.assigned.contact_number}`}>
                              {order.assigned.contact_number}
                            </a>
                          }
                        />
                      </InfoBox>
                    ) : null}
                  </Col>
                </Row>

                {/* ── Schedule ── */}
                <SectionHeader title="Schedule" icon="mdi-calendar-clock" />
                <Row className="g-3">
                  <Col md={6}>
                    <div className="mb-1">
                      <span
                        className="text-muted"
                        style={{ fontSize: "0.72rem" }}
                      >
                        Pickup Date
                      </span>
                      {[0, 1].includes(order.status) ? (
                        <span
                          role="button"
                          className="badge rounded-pill bg-soft-primary text-primary ms-2"
                          style={{
                            cursor: "pointer",
                            fontSize: "0.72rem",
                            padding: "3px 8px",
                          }}
                          onClick={() => {
                            if (order.time_slot) {
                              setPickupDate(
                                dayjs(order.time_slot).format("YYYY-MM-DD")
                              )
                              setPickupTime(
                                dayjs(order.time_slot).format("HH:mm")
                              )
                            } else {
                              setPickupDate("")
                              setPickupTime("")
                            }
                            setShowPickupDateModal(true)
                          }}
                        >
                          <i className="mdi mdi-pencil me-1" />
                          Edit
                        </span>
                      ) : null}
                    </div>
                    <div className="fw-medium">
                      {order.time_slot
                        ? dayjs(order.time_slot).format("MMMM DD, YYYY hh:mm A")
                        : "N/A"}
                    </div>
                    <div className="mt-1">
                      {getOrderStatus(
                        "light",
                        order.is_scheduled ? "Scheduled" : "Same-Day"
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div
                      className="text-muted mb-1"
                      style={{ fontSize: "0.72rem" }}
                    >
                      Delivery Date
                    </div>
                    <div className="fw-medium">
                      {order.delivery_time
                        ? dayjs(order.delivery_time).format(
                            "MMMM DD, YYYY hh:mm A"
                          )
                        : "N/A"}
                    </div>
                  </Col>
                </Row>

                {/* ── Package & Order Details ── */}
                <SectionHeader
                  title="Package & Order Details"
                  icon="mdi-package-variant"
                />
                <Row className="g-3">
                  <Col md={6}>
                    <InfoRow label="Package Type" value={order?.package_type} />
                    <InfoRow
                      label="Package Weight"
                      value={
                        order?.package_weight
                          ? getPackageWeight(order.package_weight)
                          : null
                      }
                    />
                    {order?.package_value ? (
                      <InfoRow
                        label="Package Value"
                        value={`${currency} ${order.package_value}`}
                      />
                    ) : null}
                  </Col>
                  <Col md={6}>
                    <InfoRow
                      label="Order Date"
                      value={
                        order.createdAt
                          ? dayjs(order.createdAt).format("MMMM DD, YYYY")
                          : null
                      }
                    />
                    {order.amount && order.amount.promo_code != "null" ? (
                      <>
                        <div
                          className="text-muted mb-1"
                          style={{ fontSize: "0.72rem" }}
                        >
                          Discount
                        </div>
                        <div className="mb-1">
                          <span className="badge bg-soft-success text-success me-1">
                            {order.amount.promo_code}
                          </span>
                          {order.amount.coupon_type && (
                            <span className="badge bg-soft-info text-info me-1">
                              {order.amount.coupon_type}
                            </span>
                          )}
                        </div>
                        <small className="text-muted">
                          Coupon Discount: {order.amount.coupon_discount}{" "}
                          &nbsp;·&nbsp; Applied: {order.amount.applied_discount}{" "}
                          &nbsp;·&nbsp; Type: {order.amount.discount_type}
                        </small>
                      </>
                    ) : null}
                  </Col>
                </Row>

                {/* ── Photos ── */}
                <SectionHeader title="Photos" icon="mdi-image-multiple" />
                <Row className="g-3">
                  <Col md={12}>
                    <div
                      className="text-muted mb-1"
                      style={{ fontSize: "0.72rem" }}
                    >
                      Package Photos
                    </div>
                    {order.package_photos_url &&
                    order.package_photos_url.length ? (
                      <div className="d-flex flex-wrap">
                        {order.package_photos_url.map((item, i) => (
                          <ImagePreview link={item} key={i} />
                        ))}
                      </div>
                    ) : (
                      <span className="text-muted">Not Available</span>
                    )}
                  </Col>
                  <Col md={6}>
                    <div
                      className="text-muted mb-1"
                      style={{ fontSize: "0.72rem" }}
                    >
                      Pickup Verification
                    </div>
                    {order.pickup_verify_image_url ? (
                      <ImagePreview
                        link={order.pickup_verify_image_url}
                        key="Pickup Verification Photo"
                      />
                    ) : (
                      <span className="text-muted">Not Available</span>
                    )}
                  </Col>
                  <Col md={6}>
                    <div
                      className="text-muted mb-1"
                      style={{ fontSize: "0.72rem" }}
                    >
                      Delivery Verification
                    </div>
                    {order.verify_image_url ? (
                      <ImagePreview
                        link={order.verify_image_url}
                        key="Delivery Verification Photo"
                      />
                    ) : (
                      <span className="text-muted">Not Available</span>
                    )}
                  </Col>
                </Row>

                {/* ── Activity Logs ── */}
                {order.is_return_order && order.activity_logs?.length ? (
                  <>
                    <SectionHeader title="Activity Logs" icon="mdi-history" />
                    <div className="table-responsive">
                      <table className="table table-sm table-hover align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Action</th>
                            <th>Message</th>
                            <th>Actor</th>
                            <th className="text-nowrap">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {order.activity_logs.map(log => (
                            <tr key={log._id}>
                              <td className="fw-medium">
                                {formatAction(log.action)}
                              </td>
                              <td className="text-muted">{log.message}</td>
                              <td>{getActorBadge(log.actor)}</td>
                              <td className="text-nowrap">
                                {dayjs(log.created_at).format(
                                  "MMM DD, YYYY hh:mm A"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : null}

                {/* ── Order Summary ── */}
                <SectionHeader title="Order Summary" icon="mdi-receipt" />
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Delivery Service Amount</th>
                        {order.amount?.return_trip_amount ? (
                          <th>Return Service Amount</th>
                        ) : null}
                        <th>From Wallet</th>
                        <th className="text-center">Applied Discount</th>
                        <th className="text-end">Total Paid</th>
                      </tr>
                    </thead>
                    {order.amount ? (
                      <tbody>
                        <tr>
                          <td>
                            {currency}{" "}
                            <strong>
                              {order.amount?.primary_trip_amount ||
                                order.amount?.total_amount ||
                                0}
                            </strong>
                          </td>
                          {order.amount?.return_trip_amount ? (
                            <td>
                              {currency}{" "}
                              <strong>{order.amount.return_trip_amount}</strong>
                            </td>
                          ) : null}
                          <td>
                            {currency} {order.amount?.wallet_amount}
                          </td>
                          <td className="text-center">
                            {currency} {order.amount?.applied_discount || 0}
                          </td>
                          <td className="text-end">
                            <strong>
                              {currency} {order.amount?.payment || 0}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    ) : null}
                  </table>
                </div>

                {[1, 2].includes(order.status) ? (
                  <div className="text-end mt-2">
                    <Button color="primary" onClick={markDelivered}>
                      <i className="mdi mdi-check-circle-outline me-1" />
                      Mark as Delivered
                    </Button>
                  </div>
                ) : null}
              </CardBody>
            </Card>
          )}
        </div>
      </div>
    </>
  )
}

export default ViewOrder
